<template>
  <div>
    <apexcharts
        :options="chartOptionsComputed"
        :series="series"
    ></apexcharts>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  name: "DayaDukungBannerChartPie",
  props:{
    dialogWidth: Number,
    series1: Array,
    labels1: Array,
  },
  components: {
    apexcharts: VueApexCharts,
  },
  watch:{
    series1: {
      handler: function (value) {
        if (value.length > 0) {
          this.series = value;
        }
      },
      immediate: true
    },
    labels1: {
      handler: function (value) {
        if (value.length > 0) {
          this.labels = value;
        }
      },
      immediate: true
    }

  },
  data: function() {
    return {
      labels: this.labels1.length ? this.labels1 :['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O'],
      series: this.series1.length ? this.series1: [1,2,3,4,5,6,7,8,9, 10, 12, 13, 14, 15],
    }
  },
  computed:{
    labelsComputed(){
      return this.labels1;
    },
    chartOptionsComputed() {
      return {
        chart: {
          width: this.dialogWidth-50,
          type: 'pie',
        },
        labels: this.labelsComputed,
        fill: {
          type: 'gradient',
        },
        legend: {
          formatter: function (val, opts) {
            // return val + " - " + opts.w.globals.series[opts.seriesIndex]

            let value = opts.w.globals.series[opts.seriesIndex];
            let valueStr = "";
            if (value / 1000000000000 > 1) {
              valueStr = `${parseFloat(value / 1000000000000).toFixed(
                  2
              )} Triliun`;
            } else if (value / 1000000000 > 1) {
              valueStr = `${parseFloat(value / 1000000000).toFixed(2)} Miliar`;
            } else if (value / 1000000 > 1) {
              valueStr = `${parseFloat(value / 1000000).toFixed(2)} Juta`;
            } else if (value / 1000 > 1) {
              valueStr = `${parseFloat(value / 1000).toFixed(2)} Ribu`;
            } else {
              valueStr = value.toString();
            }

            return val + " - " + valueStr;
          },
          position: "right",
        },
        tooltip: {
          y: {
            formatter: function (value) {
              let valueStr = "";
              if (value / 1000000000000 > 1) {
                valueStr = `${parseFloat(value / 1000000000000).toFixed(2)} Triliun`;
              } else if (value / 1000000000 > 1) {
                valueStr = `${parseFloat(value / 1000000000).toFixed(2)} Miliar`;
              } else if (value / 1000000 > 1) {
                valueStr = `${parseFloat(value / 1000000).toFixed(2)} Juta`;
              } else if (value / 1000 > 1) {
                valueStr = `${parseFloat(value / 1000).toFixed(2)} Ribu`;
              } else {
                valueStr = value.toString();
              }

              return valueStr;
            }
          }
        },
        responsive: [{
          options: {
            chart: {
              type: 'pie'
            },
            legend: {
              position: 'bottom'
            }
          },
        }]
      }
    }
  },
  methods:{
  },
  mounted() {
    // Mengatur nilai awal series dan labels jika belum diatur
    if (this.series1.length > 0) {
      this.series = this.series1;
    }
    if (this.labels1.length > 0) {
      this.labels = this.labels1;
    }
  }

}
</script>

<style scoped>

</style>